import { IBaseShortcutKeyManagerInjectable } from '../../core/interface';

export default class BaseShortcutKeyManagerInjectable implements IBaseShortcutKeyManagerInjectable {

}
